import { useEffect, useState } from "react";
import { api, fmtMoney } from "@/lib/api";
import { MetricCard, PageHeader, Section, Pill } from "@/components/ui-kit";
import { Building2, CreditCard, Users, Banknote, Landmark } from "lucide-react";

export default function GlobalAdminDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/dashboard/global").then(({ data }) => setData(data)).catch(() => setData(null));
  }, []);
  if (!data) return <div className="label" data-testid="loading">Loading…</div>;

  return (
    <div data-testid="global-admin-dashboard">
      <PageHeader title="Platform Overview" subtitle="Global Admin" testId="page-header" />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <MetricCard label="Tenants" value={data.companies_total} icon={Building2} testId="metric-tenants" sub={`${data.active_subscriptions} active · ${data.trial_subscriptions} trial`} />
        <MetricCard label="Platform Revenue" value={fmtMoney(data.platform_revenue)} icon={Landmark} accent="sage" testId="metric-revenue" sub="From paid subscriptions" />
        <MetricCard label="Customers (all tenants)" value={data.customers_total} icon={Users} testId="metric-customers" />
        <MetricCard label="Loans (all tenants)" value={data.loans_total} icon={Banknote} accent="terracotta" testId="metric-loans" />
      </div>

      <Section title="Recent Payments" testId="recent-payments">
        {data.recent_payments?.length ? (
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left">
                <th className="label py-2">Date</th>
                <th className="label py-2">Company</th>
                <th className="label py-2">Plan</th>
                <th className="label py-2">Cycle</th>
                <th className="label py-2 text-right">Amount</th>
                <th className="label py-2 text-right">Status</th>
              </tr>
            </thead>
            <tbody>
              {data.recent_payments.map((p) => (
                <tr key={p.id} className="border-t border-border">
                  <td className="py-2.5">{new Date(p.created_at).toLocaleDateString()}</td>
                  <td className="py-2.5 font-mono text-xs">{p.company_id?.slice(0, 8)}…</td>
                  <td className="py-2.5">{p.plan_id?.slice(0, 8)}…</td>
                  <td className="py-2.5 capitalize">{p.billing_cycle || "—"}</td>
                  <td className="py-2.5 text-right tabular-nums">{fmtMoney(p.amount, p.currency)}</td>
                  <td className="py-2.5 text-right">
                    <Pill variant={p.status === "PAID" ? "success" : p.status === "FAILED" ? "warning" : "info"}>{p.status}</Pill>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="text-sm text-muted-foreground py-6 text-center" data-testid="empty-payments">No payments yet.</div>
        )}
      </Section>
    </div>
  );
}
